import { render, staticRenderFns } from "./TwoFaPincodeDialog.vue?vue&type=template&id=fa4766fc&scoped=true"
import script from "./TwoFaPincodeDialog.vue?vue&type=script&lang=js"
export * from "./TwoFaPincodeDialog.vue?vue&type=script&lang=js"
import style0 from "./TwoFaPincodeDialog.vue?vue&type=style&index=0&id=fa4766fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa4766fc",
  null
  
)

export default component.exports